import api from './api';

export const getUserIPData = async () => {
  const API = `${window.shopUrl}/browsing_context_suggestions.json`

  const response = await api.read(API);

  return response;
}
